import { render, staticRenderFns } from "./CustomFieldList.vue?vue&type=template&id=494bec5a"
import script from "./CustomFieldList.vue?vue&type=script&lang=js"
export * from "./CustomFieldList.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldList.vue?vue&type=style&index=0&id=494bec5a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports